<span class="section-title"> {{ sectionTitle() }}</span>

<div class="content">
  <ng-content />
</div>
